import { useTranslation } from "react-i18next";
import clsx from "clsx";

import classes from "./styles.module.scss";

import { Chip } from "@components/atoms/chip";

export function TableNoData() {
  const { t } = useTranslation("common");

  return (
    <div className={clsx(classes.noData)}>
      <Chip name={"nodata"} value={t("no_data")} />
    </div>
  );
}
